const GraphqlData = window.GraphqlData;
export const Showroom = {
  props: ["manufacturer", "otherBrands", "financeFrequency", "leaseFrequency", "province", "imagePath", "lang", "graphqlEndpoint","excludedModels","excludedTrims","excludedCategories"],
  data() {
    return {
      makeSelected: this.manufacturer,
      brands: null,
      allVehicles: [],
      actualVehicles: null,
      actualCategories: null,
      loadingBrands: true,
      selectedCategory: '',
    };
  },
  created() {
    // Verificar si los datos ya están en sessionStorage
    if (sessionStorage.getItem('brands') && sessionStorage.getItem('actualVehicles') && sessionStorage.getItem('actualCategories') && sessionStorage.getItem('allVehicles')) {
      this.brands = JSON.parse(sessionStorage.getItem('brands'));
      this.actualVehicles = JSON.parse(sessionStorage.getItem('actualVehicles'));
      this.actualCategories = JSON.parse(sessionStorage.getItem('actualCategories'));
      this.allVehicles = JSON.parse(sessionStorage.getItem('allVehicles'));
      this.loadingBrands = false;
      return; // Salir del método si los datos ya están cargados
    }
  
    // Unir la marca seleccionada con el array de las otras marcas
    let allBrands = [this.manufacturer.toLowerCase()];
    if (this.otherBrands.length > 0) {
      allBrands = allBrands.concat(this.otherBrands.map(brand => brand.toLowerCase()));
    }
    this.brands = allBrands;
  
    GraphqlData.authenticateAndFetchData(this.manufacturer.toLowerCase(), 'bp-models', null, null, this.graphqlEndpoint)
      .then((result) => {
        result = result.map(vehicle => ({
          ...vehicle,
          loading: true,
          modelData: {
            ...vehicle.modelData,
            financeOffers: Array.isArray(vehicle.modelData.financeOffers)
              ? vehicle.modelData.financeOffers.find(offer => offer.regionKey === this.province)
              : null,
            leaseOffers: Array.isArray(vehicle.modelData.leaseOffers)
              ? vehicle.modelData.leaseOffers.find(offer => offer.regionKey === this.province)
              : null,
            name: `${vehicle.modelData.year} ${vehicle.modelData.model}`,
          }
        }));
  
        this.actualVehicles = result;
        this.actualVehicles = this.actualVehicles.filter(vehicle => !this.excludedModels.includes(vehicle.modelData.name));
  
        this.actualCategories = [...new Set(result.flatMap(vehicle => vehicle.modelData.category))];
        this.actualCategories = this.actualCategories.filter(category => !this.excludedCategories.includes(category));
  
        // Almacenar en sessionStorage
        sessionStorage.setItem('actualVehicles', JSON.stringify(this.actualVehicles));
        sessionStorage.setItem('actualCategories', JSON.stringify(this.actualCategories));
      })
      .catch((error) => {
        console.error("Error:", error.message);
      });
  
    // Crear un array de promesas
    const promises = allBrands.map(brand => {
      return GraphqlData.authenticateAndFetchData(brand, 'bp-models',null, null, this.graphqlEndpoint)
        .then((result) => {
          result = result.map(vehicle => ({
            ...vehicle,
            loading: true,
            modelData: {
              ...vehicle.modelData,
              financeOffers: Array.isArray(vehicle.modelData.financeOffers)
                ? vehicle.modelData.financeOffers.find(offer => offer.regionKey === this.province)
                : null,
              leaseOffers: Array.isArray(vehicle.modelData.leaseOffers)
                ? vehicle.modelData.leaseOffers.find(offer => offer.regionKey === this.province)
                : null,
              name: `${vehicle.modelData.year} ${vehicle.modelData.model}`
            }
          }));
  
          this.allVehicles.push({ [brand]: result });
        })
        .catch((error) => {
          console.error("Error:", error.message);
        });
    });
  
    // Usar Promise.all para saber cuándo todas las promesas se han cumplido
    Promise.all(promises)
      .then(() => {
        this.loadingBrands = false;
  
        // Almacenar en sessionStorage
        sessionStorage.setItem('brands', JSON.stringify(this.brands));
        sessionStorage.setItem('allVehicles', JSON.stringify(this.allVehicles));
      })
      .catch((error) => {
        console.error("Error en alguna de las promesas:", error.message);
      });
  },
  mounted() {
  },
  methods: {
    filterBrand(brand) {
      if(!this.loadingBrands){
        this.actualVehicles = null;
        this.actualCategories = null;
        this.selectedCategory = '';

        //setTimeout(() => {          
          this.makeSelected = brand;
    
          // Filtrar los vehículos por marca
          this.actualVehicles = this.allVehicles
            .reduce((acc, vehicle) => {
              if (vehicle[brand]) {
                return acc.concat(vehicle[brand]);
              }
              return acc;
            }, []);
          
          this.actualVehicles = this.actualVehicles.filter(vehicle => !this.excludedModels.includes(vehicle.modelData.name));

          this.actualCategories = [...new Set(this.actualVehicles.flatMap(vehicle => vehicle.modelData.category))];

          // Excluir las categorias que esten en el array de excludedCategories
          this.actualCategories = this.actualCategories.filter(category => !this.excludedCategories.includes(category));

        //}, 200);
      }
    },
    getLease(vehicle){
      return (vehicle.modelData?.leaseOffers?.mileage ? this.$options.filters.mileageFormat(vehicle.modelData.leaseOffers.mileage,this.lang) : 'XX'); ;
    },
    getFinanceTotal(vehicle) {
      if(vehicle){
        const price = vehicle.startingPrice;
        const rate = vehicle?.financeOffers?.rate || 0;
        const term = vehicle.financeOffers?.term || 0;

        if (price !== 0 && rate !== 0 && term !== 0) {
          let financeFrequency = this.financeFrequency || 'Monthly';
          // Calcular el total de financiamiento
          const monthlyRate = rate / 1200;
          const financeTotal = Math.round(
            ((price * monthlyRate * Math.pow(1 + monthlyRate, term)) /
              (Math.pow(1 + monthlyRate, term) - 1)) *
              100
          ) / 100;
      
          let adjustedFinanceTotal;
      
          // Ajustar según la frecuencia de financiamiento
          switch (financeFrequency) {
            case 'Weekly':
              adjustedFinanceTotal = Math.round((financeTotal * 12) / 52);
              break;
            case 'Bi-Weekly':
              adjustedFinanceTotal = Math.round(((financeTotal * 12) / 52) * 2);
              break;
            case 'Monthly':
            default:
              adjustedFinanceTotal = Math.round(financeTotal);
              break;
          }
      
          return adjustedFinanceTotal;
        }
        return null;
      }
    },   
    getLeaseTotal(vehicle) {
      if(vehicle){
        const price = vehicle.startingPrice;
        const rate = vehicle?.leaseOffers?.rate || 0;
        const term = vehicle.leaseOffers?.term || 0;
        const residual = vehicle.leaseOffers?.residual || 0;

        if (price !== 0 && rate !== 0 && term !== 0 && residual !== 0) {
          const moneyFactor = rate / 2400;
          const newResidual = price * (residual / 100);
          const leaseFrequency = this.leaseFrequency || 'Monthly';
          let depreciation = 0;
        
          if (term > 0) {
            depreciation = (price - newResidual) / term;
          }
        
          const financeFee = (price + newResidual) * moneyFactor;
          const monthlyLease = financeFee + depreciation;
        
          // Simulación de la función get_leadbox_finance_settings()
        
          let leaseTotal = 0;
          switch (leaseFrequency) {
            case 'Weekly':
              leaseTotal = Math.round((monthlyLease * 12) / 52);
              break;
            case 'Bi-Weekly':
              leaseTotal = Math.round((monthlyLease * 12) / 26);
              break;
            case 'Monthly':
              leaseTotal = Math.round(monthlyLease);
              break;
          }
        
          return leaseTotal;
        }
        return null;
      }
    },
    filterByCategory(category) {
      this.selectedCategory = category;
    },
    matchesCategory(vehicle) {
      if (!this.selectedCategory || this.selectedCategory == 'All') return true;
      const categories = (vehicle.modelData.category || []).map(category => category);
      return categories.includes(this.selectedCategory);
    },
    onLoad(index) {
      if (Array.isArray(this.actualVehicles) && index >= 0 && index < this.actualVehicles.length) {
        if (!this.actualVehicles[index]) {
            this.$set(this.actualVehicles, index, { loading: false });
        } else {
            this.actualVehicles[index].loading = false;
        }
      }
    },
    onError(index) {
      this.actualVehicles[index].loading = false;
      this.actualVehicles[index].error = true;
    },
    isMoreThanOne(array) {
      return array.length > 1;
    },
    getDefaultImg(vehicleType) {
      // Asegúrate de tomar el primer elemento si es un array
      const firstType = Array.isArray(vehicleType) ? vehicleType[0] : vehicleType;
    
      // Convertir a minúsculas para comparación
      const lowerType = firstType.toLowerCase();
    
      // Switch para determinar la imagen
      switch (lowerType) {
        case 'cars':
          return `${this.imagePath}car-silhouette.svg`;
        case 'suv & crossover':
          return `${this.imagePath}suv-silhouette.svg`;
        case 'trucks':
          return `${this.imagePath}truck-silhouette.svg`;
        default:
          return `${this.imagePath}car-silhouette.svg`;
      }
    },
    loadingTemplate() {
      return `
      <div role="status" class="flex items-center justify-center">
        <svg aria-hidden="true" class="w-8 h-8 mr-2 text-gray-200 animate-spin"
          viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor" />
          <path class="text-primary fill-current"
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="none" />
        </svg>
      </div>
      <span class="flex items-center font-primary-bold justify-center loading-text">${
        this.lang == "en-CA" ? "Loading" : "Chargement"
      }...</span>`;
    },
  },
  filters: {
    moneyFormat:(price, lang, digits = 0)=>{
      var formatter = new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: digits,
      });
      return ( digits != 0) ? formatter.format(price) : formatter.format(Math.floor(price));
    },
    mileageFormat:(mileage,lang)=>{

      const formatter = new Intl.NumberFormat(lang, {
        style: 'unit',
        unit: 'kilometer'
      });
     
     return formatter.format(Math.floor(mileage));
    },
  },
};